export default {
  setUser: (state, value) => (state.user = value)
}
